import React, { useState, useEffect, Fragment } from 'react';
import ReactTable from 'react-table';
import { toast } from 'react-toastify';
import Breadcrumb from '../common/breadcrumb';
import Loader from '../common/loader';
import api from '../../config/axios';
import utils from '../../utils/miscUtils';

const PAGOS_RECIBIDOS_ENDPOINT = '/misc/pago-movil';

function ItemPagosRecibidos({ data }) {
    return (
        <div className="wrapper-order-item">
            <div>
                <div style={{ fontSize: 16, margin: 0, padding: 0 }} className="d-flex justify-content-between align-items-center">
                    <span style={{ fontSize: 18 }}>Bs <strong>{data.monto}</strong></span>
                    <span style={{ fontSize: 14}}>{data.hora}</span>
                </div>
                <div style={{ fontSize: 16, margin: '6px 0 0 0', padding: 0 }} className="d-flex justify-content-between align-items-center">
                    <span>Ref: <strong>{data.referencia}</strong></span>
                    <span style={{ fontSize: 14}}>{data.dia}</span>
                </div>
                <div style={{ fontSize: 16, margin: 0, padding: 0 }}>
                    🏦 {data.bank}
                </div>
                <div style={{ fontSize: 16, margin: 0, padding: 0 }} className="d-flex justify-content-between align-items-center">
                    <span>📱 <strong>{data.remitente}</strong></span>
                    <p className="text-right" style={{ fontSize: 14}}>
                        <strong>{data.type}</strong>
                    </p>
                </div>
            </div>
        </div>
    );
}

const columnsDataTable = [
    {
        Cell: (row) => <ItemPagosRecibidos data={row.original} />,
        style: {
            textAlign: 'center',
            width: '100%',
        },
        sortable: false,
        width: '100%',
    },
];

function PagosRecibidos() {
    const [pagosRecibidos, setPagosRecibidos] = useState({
        list: [],
        loaded: false,
    });

    useEffect(() => {
        fetchPagosRecibidos();
    }, []);

    const fetchPagosRecibidos = async () => {
        try {
            const { data } = await api.get(PAGOS_RECIBIDOS_ENDPOINT);
            const list = parseToDatatable(data.data || []);

            setPagosRecibidos({
                loaded: true,
                list,
            });
        } catch (error) {
            toast.error('Error cargando los pagos recibidos. Intenta nuevamente.');
            setPagosRecibidos({
                loaded: true,
                list: [],
            });
        }
    };

    const formatMonto = (monto) => {
        if (monto === null || monto === undefined || monto === '') {
            return '-';
        }

        const numericMonto = Number(monto);
        if (!Number.isNaN(numericMonto)) {
            return utils.currency(numericMonto);
        }

        return monto;
    };

    const parseToDatatable = (array) => {
        return array.map((item, index) => ({
            id: item.id || index,
            type: item.type || item.bank || '-',
            referencia: item.referencia || item.reference || '-',
            monto: formatMonto(item.monto ?? item.amount),
            remitente: item.lastDigitsPhone || item.sender || '-',
            bank: item.bank || '-',
            dia: new Date(item.date).toLocaleDateString('es-VE'),
            hora: new Date(item.date).toLocaleTimeString('es-VE'),
        }));
    };

    if (!pagosRecibidos.loaded) {
        return (
            <div style={{ display: 'flex', height: '50vh' }}>
                <Loader />
            </div>
        );
    }

    return (
        <Fragment>
            <Breadcrumb title="Pagos recibidos" />
            <div className="container-fluid">
                <div className="row">
                    <div className="col-sm-12">
                        <div className="card">
                            <div className="card-body">
                                <div className="clearfix"></div>
                                <div className="table-boxes">
                                    <ReactTable
                                        columns={columnsDataTable}
                                        className="-striped -highlight"
                                        multiSelectOption={false}
                                        data={pagosRecibidos.list}
                                        page={0}
                                        defaultPageSize={10}
                                        showPageSizeOptions={false}
                                        showPagination={pagosRecibidos.list.length > 10}
                                        manual
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </Fragment>
    );
}

export default PagosRecibidos;
